
import Vue from 'vue'
import { CheckoutPageModel } from '@ViewModels/CheckoutPageModel'
import { DropDownSelect } from '@/components/formGroups'
import EditAddressForm from './AddressEditForm.vue'
import { PartyStreetAddressModel } from '@ViewModels/PartyStreetAddressModel'
import { StoreCheckoutDto } from '@ViewModels/StoreCheckoutDto'

export default Vue.extend({
   name: 'ShippingAddress',
   data() {
      return {
         selectedAddressId: 'new',
      }
   },
   computed: {
      modelData(): CheckoutPageModel {
         return this.$store.state.modelData
      },
      purchase(): StoreCheckoutDto {
         return this.$store.state.purchase
      },
      isSchoolOrder(): boolean {
         return !this.purchase.IsPersonalOrder
      },
      schoolName(): string {
         return this.$store.getters.schoolName
      },
      schoolAddress(): string {
         return this.modelData.SchoolId
            ? this.modelData.SchoolAddress
            : this.$store.state.schoolLookup.schoolAddress
      },
      addresses(): PartyStreetAddressModel[] {
         return this.$store.state.modelData.Addresses
      },
      addressOptions(): NameValuePair[] {
         const options = this.addresses.map(address => ({
            name: address.FormattedAddress,
            value: address.Id + '',
         }))
         options.push({ name: '', value: '-' })
         options.push({ name: 'Add new address', value: 'new' })
         return options
      },
      showErrors(): boolean {
         return this.$store.state.showErrors
      },
   },
   methods: {
      update() {
         const address = this.addresses.find(c => c.Id === this.selectedAddressId)
         if (address) {
            this.$store.dispatch('setShippingAddressId', this.selectedAddressId)
         }
      },
   },
   mounted() {
      if (!!this.purchase.ShippingAddressId) {
         this.selectedAddressId = this.purchase.ShippingAddressId
      } else if (this.modelData.Addresses.length > 0) {
         this.selectedAddressId = ''
      }
   },
   components: {
      EditAddressForm,
      DropDownSelect,
   },
})
